module.exports = __webpack_public_path__ + "static/media/tools-question.15ce9110.svg";